"use client"
import React, { useEffect, useState } from 'react'
import { ModalWrapper } from '../wrapperComponents/page'
import formatMsg from '../../util/formatMsg'
import BookingCalendar from './BookingCalendar'
import Helper from '../../util/helper'
import { canBackdateBookings } from '../../util/godMode'
import { Button, Skeleton, Spin } from 'antd'
import { useDispatch } from 'react-redux'
import { getRescheduleData } from '../../redux/package/reducer'
import "./style.css"
import { notification } from '../../util/notification'
import { rescheduleBooking } from '../../redux/accountPackage/reducer'
import { accountPackageActions, colors, packageActions, PrefixIconButton } from '../..'
import { initialState as initialAccountPackageReducer } from '../../redux/accountPackage/reducer';
import { initialState as initialPackageReducer } from '../../redux/package/reducer';
import { PERIOD_COUNTING } from '../../util/limitWindows';
import { timeutil } from 'sharedresources'
import { Moment } from 'moment'
import moment from "moment-timezone";
import { getInstanceClone } from '../../util/timeutil'
import { isMonthDaysPerWeekPack } from '../../util/pricingPackWeekdays'
import ViewActivityModal from '../activity/ViewActivityModal';

const formatTime = (epoch: number) => timeutil.getInstance(epoch).format("h:mm A");

const RescheduleBookingModal = ({ open, setOpen, credits = null, remainingCredits = 0, readOnly = false, modalType = null, packageId = null }) => {
	const dispatch = useDispatch();
	const { packageReducer, accountPackageReducer, firebase } = Helper.getSelectorState(["packageReducer", "accountPackageReducer"])
	const [selectedPricingPack, setSelectedPricingPack] = useState<any>({})
	const [selectedBatch, setSelectedBatch] = useState<any>({});
	const [selectedWeeks, setSelectedWeeks] = useState<string[]>([]);
	const [selectedDays, setSelectedDays] = useState<Date[]>([]);
	const [selectedMonths, setSelectedMonths] = useState<Moment[]>([]);
	const [currentMonth, setCurrentMonth] = useState(timeutil.getInstance());
	const [selectedTimings, setSelectedTimings] = useState<Record<string, Record<string, string | string[]>>>({});
	const [selectedWeekDays, setSelectedWeekDays] = useState<any>([]);
	const [groupedTimings, setGroupedTimings] = useState<any>({});
	const [pricePackDuration, setPricePackDuration] = useState(1);
	const [commonAvailability, setCommonAvailability] = useState(0);
	const [numbers, setNumbers] = useState({
		selectedWeeks: 0,
		selectedDays: 0,
		selectedMonths: 0,
		selectedWeekDays: 0
	});
	const [afterReSchedule, setAfterReSchedule] = useState(false);
	const [openActivityId, setOpenActivityId] = useState();
	const [packageActivityMap, setPackageActivityMap] = useState(new Map());

	const { batchSlotMap, maxCapacityPerBatchCenter, allowWaitlist, waitlistCapacity } = accountPackageReducer;

	useEffect(() => {
		return () => {
			dispatch(accountPackageActions.sliceOperation(initialAccountPackageReducer))
			dispatch(packageActions.sagaSuccess(initialPackageReducer))
		}
	}, [])

	useEffect(() => {
		let id = Helper.getUrlParam("id");
		if (packageReducer.rescheduleData.centerId && selectedBatch.id) {
			!readOnly && dispatch(accountPackageActions.getAvailabilityMapForSlots({ firebase, reqObj: { batchId: selectedBatch.id, centerId: packageReducer.rescheduleData.centerId, packageId: packageId } }));
		}

	}, [selectedBatch, packageReducer.rescheduleData.centerId])

	useEffect(() => {
		if (open) {
			dispatch(getRescheduleData({ firebase, bookingId: open }))
		}
	}, [open])

	useEffect(() => {
		if (accountPackageReducer.operationType === "BOOKING_RESCHEDULED") {
			notification("success", formatMsg("success.bookingReschedules"))
			setAfterReSchedule(true);
			dispatch(accountPackageActions.sliceOperation({ operationType: undefined }))
		}
	}, [accountPackageReducer.operationType])

	useEffect(() => {
		let tempPackage;
		let mergeSlots;
		if (packageReducer.rescheduleData?.pricePack?.frequency === "ENTIRE_PACKAGE_DURATION" && !readOnly) {
			notification("error", formatMsg("cannotRescheduleEntirePackage"))
			setOpen(false);
		}
		if (packageReducer.rescheduleData.batch) {
			tempPackage = packageReducer.rescheduleData.batch
			mergeSlots = processBatchTimings(tempPackage)
			setSelectedBatch(tempPackage);
		}
		if (packageReducer.rescheduleData.pricePack) {
			setSelectedPricingPack({ pricingPack: packageReducer.rescheduleData.pricePack })
		}
		if (packageReducer.rescheduleData.slots) {
			const startDate = timeutil.getInstance(packageReducer.rescheduleData.slots?.[0]?.date);
			const endDate = timeutil.getInstance(packageReducer.rescheduleData.slots[packageReducer.rescheduleData.slots.length - 1].date);

			let date = moment.max(startDate, timeutil.getInstance());
			date = date.isAfter(endDate) ? startDate : date

			setCurrentMonth(date)
			const updatedWeeks = new Set<string>();
			const updatedDays: Date[] = [];
			const updatedMonths = new Set<number>();
			const newSelectedTimings: Record<string, Record<string, string[]>> = {};
			const updatedWeekDays = new Set<string>();

			for (const { slotRandomId, date, startTime, endTime, activityId } of packageReducer.rescheduleData.slots) {
				const day = timeutil.getInstance(date);
				const isRecurring = tempPackage.type === "recurring";
				const actKey = activityId ?? "default";
				const formattedDate = Helper.convertToDate(day, firebase);
				const formattedMonth = timeutil.getEpoch(getInstanceClone(day).startOf("month"));
				const weekLabel = `Week+${timeutil.getEpoch(timeutil.getStartOfWeek(day, tempPackage?.weekStartDay))}`;
				if (!newSelectedTimings[actKey]) {
					newSelectedTimings[actKey] = {};
				}

				updatedWeeks.add(weekLabel);
				if (!updatedDays.some(d => d.getTime() === formattedDate.getTime()))
					updatedDays.push(formattedDate);
				updatedMonths.add(formattedMonth);
				updatedWeekDays.add(day.format("dddd").toUpperCase())

				const timeLabel = `${formatTime(startTime)} - ${formatTime(endTime)}`;
				const useCommon = mergeSlots[actKey]?.["Common slots"];
				const innerKey = useCommon
					? "Common slots"
					: isRecurring
						? day.format("dddd").toUpperCase()
						: day.format(Helper.dateFormat(firebase));

				const randomId = useCommon
					? mergeSlots[actKey]?.["Common slots"]?.find(obj => obj.label === timeLabel)?.key
					: slotRandomId;

				const bucket = newSelectedTimings[actKey][innerKey] ||= [];
				if (!bucket.includes(randomId)) {
					bucket.push(randomId);
				}
			}
			setSelectedWeeks(Array.from(updatedWeeks));
			setSelectedDays(updatedDays);
			setSelectedMonths(Array.from(updatedMonths).map(d => timeutil.getInstance(d)));
			setSelectedTimings(prev => {
				const next = {};
				for (const [actKey, daysMap] of Object.entries(newSelectedTimings)) {
					const existing = next[actKey] ?? {};
					next[actKey] = { ...existing, ...daysMap };
				}

				return next;
			});

			// For CUSTOM with DURATION, add all weekdays (Monday to Sunday)
			let finalWeekDays = Array.from(updatedWeekDays);
			if (packageReducer.rescheduleData?.pricePack?.frequency === "CUSTOM" &&
				packageReducer.rescheduleData?.pricePack?.durationType === "DURATION") {
				const allWeekdays = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
				const weekDaysSet = new Set([...finalWeekDays, ...allWeekdays]);
				finalWeekDays = Array.from(weekDaysSet);
			}

			setSelectedWeekDays(finalWeekDays);

			setNumbers({
				selectedWeeks: Array.from(updatedWeeks)?.length || 0,
				selectedDays: updatedDays?.length || 0,
				selectedMonths: Array.from(updatedMonths)?.length || 0,
				selectedWeekDays: finalWeekDays?.length || 0
			})
		}

		if (packageReducer.rescheduleData.pricePackDuration) {
			setPricePackDuration(packageReducer.rescheduleData.pricePackDuration)
		}

		if (packageReducer.rescheduleData.packageActivity) {
			const tempPackageActivityMap = new Map();
			packageReducer.rescheduleData.packageActivity?.forEach(act => {
				tempPackageActivityMap.set(act.id, act);
			});
			setPackageActivityMap(tempPackageActivityMap);
		}
	}, [packageReducer.rescheduleData])

	useEffect(() => {
		if (selectedBatch.id) {
			let val = processBatchTimings(selectedBatch || {})
			setGroupedTimings(processBatchTimings(selectedBatch || {}))
		}
	}, [selectedBatch])

	const processBatchTimings = (batch: any) => {
		const activityGroups = {};

		batch.intervals?.forEach((interval: any) => {
			const activityKey = interval.activityId ?? 'default';
			if (!activityGroups[activityKey]) {
				activityGroups[activityKey] = {};
			}
			const groupTimings = activityGroups[activityKey];

			const slotKey =
				batch.type === 'recurring'
					? interval.day
					: timeutil
						.getInstance(interval.date)
						.format(Helper.dateFormat(firebase));

			if (!groupTimings[slotKey]) {
				groupTimings[slotKey] = [];
			}
			groupTimings[slotKey].push({
				key: interval.randomId,
				label: `${formatTime(interval.startTime)} - ${formatTime(
					interval.endTime
				)}`,
			});
		});
		const mergedByActivity =
			Object.fromEntries(
				Object.entries(activityGroups).map(([activity, slotsByDay]: any) => [
					activity,
					Helper.mergeCommonSlots(slotsByDay, batch.sameTimings),
				])
			);

		const mergedByDate: Record<string, { activity: string; key: string }[]> = {};

		Object.entries(mergedByActivity).forEach(
			([activity, slotsByDay]) => {
				Object.entries(slotsByDay).forEach(([dayOrDate, timings]) => {
					timings.forEach(t => {
						if (!mergedByDate[dayOrDate]) mergedByDate[dayOrDate] = [];
						mergedByDate[dayOrDate].push({ activity, key: t.key });
					});
				});
			}
		);

		Object.entries(mergedByDate).forEach(([dayOrDate, entries]) => {
			if (entries.length === 1) {
				const { activity, key } = entries[0];
				handleTimingClick(activity, dayOrDate, key, true);
			}
		});

		// place default one's at last place
		const def = mergedByActivity['default'];
		delete mergedByActivity['default']
		mergedByActivity.default = def;

		return mergedByActivity;
	}

	const disabled: any = (date, tempPack?) => {
		// if (timeutil.getInstance(date).format("DD").includes("10")) 
		const selectedPack = tempPack || selectedPricingPack?.pricingPack
		const time = timeutil.getEpoch(timeutil.getInstance(date).endOf("day"));
		const month = timeutil.getEpoch(timeutil.getInstance(date).startOf("month"));
		if (selectedBatch?.excludedDates?.map(d => timeutil.getEpoch(timeutil.getInstance(d).endOf("day"))).includes(time)) return true

		if (selectedPack?.frequency === "MONTH" && selectedPack?.frequencyType && !selectedPack.all) {
			const isMonthSelected = selectedMonths.some((selected) =>
				timeutil.getInstance(selected).startOf("month").isSame(month)
			);
			if (!isMonthSelected) return true;
		}

		// Matches the add-booking flows: an operator who has taken control may move a
		// booking into the past, so a correction is not blocked halfway through.
		// See canBackdateBookings().
		const isPastAndBlocked =
			timeutil.isBefore(time, timeutil.getInstance(), "day", false) &&
			!canBackdateBookings();

		if (selectedBatch.type === "recurring") {
			let start = selectedBatch.startDate;
			let end = selectedBatch.endDate;
			if (selectedPack?.frequency === "CUSTOM") {
				if (selectedPack?.startDate) start = Math.max(start, selectedPack?.startDate);
				if (selectedPack?.endDate) end = Math.min(end, selectedPack?.endDate)
			}
			const validWeekdays = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"].filter(w =>
				selectedBatch.intervals.some(interval => interval.day === w)
			);
			const dayOfWeek = timeutil.getInstance(date).format("dddd").toUpperCase();
			return time < start || time > end || !validWeekdays.includes(dayOfWeek) || isPastAndBlocked;
		} else {
			const intervalDates = selectedBatch.intervals.map((interval) => timeutil.getEpoch(timeutil.getInstance(interval.date).endOf("day")));
			return !intervalDates.includes(time) || isPastAndBlocked;
		}
	}

	const handleTimingClick = (
		activityId: string,
		dayOrDate: string,
		timingKey: string,
		force = false,
		availability?: string
	) => {
		setSelectedTimings(prev => {
			const next = { ...prev };
			const isMultiple = !!selectedBatch?.allowMultipleTimeSlots;
			if (isMultiple && !force) {
				if (!next[activityId]) next[activityId] = {};
				const activitySelection = { ...next[activityId] };

				const currentArr = Array.isArray(activitySelection[dayOrDate])
					? (activitySelection[dayOrDate] as string[])
					: [];
				const hasIt = currentArr.includes(timingKey);

				activitySelection[dayOrDate] = hasIt
					? currentArr.filter(t => t !== timingKey)
					: [...currentArr, timingKey];

				next[activityId] = availability != "sold out" && activitySelection;
				return next;
			}

			const existing = prev[activityId]?.[dayOrDate];
			const togglingOff = existing === timingKey && !force;

			Object.keys(next).forEach(act => {
				if (next[act]?.[dayOrDate] !== undefined) {
					const clone = { ...next[act] };
					delete clone[dayOrDate];
					next[act] = clone;
				}
			});

			if (!togglingOff && availability != "sold out") {
				if (!next[activityId]) next[activityId] = {};
				next[activityId] = {
					...next[activityId],
					[dayOrDate]: [timingKey],
				};
			}

			return next;
		});
	};

	// Extract number of windows allowed from credits (payload?.credits represents number of windows allowed)
	const getMaxWindows = (): number => {
		const creditsData = credits;
		if (typeof creditsData === 'object' && creditsData !== null && creditsData.totalCredits !== undefined) {
			return creditsData.totalCredits;
		} else if (typeof creditsData === 'number') {
			return creditsData;
		}
		return 0;
	};
	const maxWindows = getMaxWindows();

	const onFinish = () => {
		if (!selectedDays?.length) {
			notification("error", formatMsg("error.selectslots"))
			return
		}
		if (commonAvailability + (waitlistCapacity || 0) <= 0) {
			notification("error", formatMsg("capacityIsFull"))
			return;
		}

		switch (selectedPricingPack.pricingPack.frequency) {
			case "MONTH":
				if (selectedMonths?.length > pricePackDuration) {
					notification("error", formatMsg("error.moreMonths"))
					return;
				}
				break;
			case "WEEK":
				if (selectedWeeks?.length > pricePackDuration) {
					notification("error", formatMsg("error.moreWeeks"))
					return;
				}
				break;
			case "DAILY":
				if (selectedDays?.length > pricePackDuration) {
					notification("error", formatMsg("error.moreDays"))
					return;
				}
				break;
		}

		let tempWeeks: any = new Set();
		let tempMonths: any = new Set();
		selectedDays.forEach(d => {
			const tempD = timeutil.getInstance(d);
			tempWeeks.add(timeutil.getEpoch(timeutil.getStartOfWeek(tempD, selectedBatch?.weekStartDay)));
			tempMonths.add(timeutil.getEpoch(tempD.clone().startOf("month")));
		})
		tempWeeks = Array.from(tempWeeks).sort((a: any, b: any) => a - b);
		tempMonths = Array.from(tempMonths).sort((a: any, b: any) => a - b);

		if (selectedBatch.atleastValue) {
			let missing = false;
			switch (selectedBatch.atleastFrequency) {
				case "days":
					if (selectedDays?.length < selectedBatch.atleastValue)
						missing = true;
					break;
				case "weeks":
					if (tempWeeks?.length < selectedBatch.atleastValue)
						missing = true;
					break;
				case "months":
					if (tempMonths?.length < selectedBatch.atleastValue)
						missing = true;
					break;
			}
			if (missing) {
				notification("error", formatMsg("error.atleast", { x: selectedBatch.atleastValue, y: selectedBatch.atleastFrequency }))
				return
			}
		}

		if (selectedBatch.onlyConsecutive) {
			switch (selectedBatch.consecutiveFrequency) {
				case "days":
					const sortedDays = [...selectedDays].sort((a, b) => a.getTime() - b.getTime());
					let daysAreConsecutive = true;
					for (let i = 1; i < sortedDays.length; i++) {
						const prevDate = timeutil.getInstance(sortedDays[i - 1]);
						const currentDate = timeutil.getInstance(sortedDays[i]);
						const dayDiff = currentDate.diff(prevDate, 'day');

						if (dayDiff === 1) continue;

						let allDisabled = true;
						let dayToCheck = prevDate.clone().add(1, 'day');
						while (dayToCheck.isBefore(currentDate)) {
							if (!disabled(dayToCheck)) {
								allDisabled = false;
								break;
							}
							dayToCheck = getInstanceClone(dayToCheck).add(1, 'day');
						}

						if (!allDisabled) {
							daysAreConsecutive = false;
							break;
						}
					}

					if ((selectedPricingPack?.pricingPack?.frequency === "WEEK" && selectedPricingPack?.pricingPack?.frequencyValue < 7) || isMonthDaysPerWeekPack(selectedPricingPack?.pricingPack)) {
						const weekDays = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"].filter(w =>
							selectedBatch.type === "recurring" ? selectedBatch.intervals.some(interval => interval.day === w) : true
						);
						const indices = selectedWeekDays.map(day => weekDays.indexOf(day)).sort((a, b) => a - b);
						for (let i = 1; i < indices.length; i++) {
							if (indices[i] !== indices[i - 1] + 1) {
								daysAreConsecutive = indices[0] === 0 && indices[indices.length - 1] === weekDays.length - 1;
								break;
							}
						}
					}

					if (!daysAreConsecutive) {
						notification("error", formatMsg("consecutiveXRequired", { x: selectedBatch.consecutiveFrequency }));
						return;
					}
					break;

				case "weeks":
					const weekStartDates = selectedWeeks.map(ws => {
						const [, timestampStr] = ws.split("+");
						return timeutil.getInstance(parseInt(timestampStr, 10));
					});
					weekStartDates.sort((a, b) => timeutil.getEpoch(a) - timeutil.getEpoch(b));
					let weeksAreConsecutive = true;
					for (let i = 1; i < weekStartDates.length; i++) {
						if (weekStartDates[i].diff(weekStartDates[i - 1], "week") !== 1) {
							weeksAreConsecutive = false;
							break;
						}
					}
					if (!weeksAreConsecutive) {
						notification("error", formatMsg("consecutiveXRequired", { x: selectedBatch.consecutiveFrequency }));
						return;
					}
					break;

				case "months":
					let monthsAreConsecutive = true;
					for (let i = 1; i < tempMonths.length; i++) {
						if (timeutil.getInstance(tempMonths[i]).diff(timeutil.getInstance(tempMonths[i - 1]), "month") !== 1) {
							monthsAreConsecutive = false;
							break;
						}
					}
					if (!monthsAreConsecutive) {
						notification("error", formatMsg("consecutiveXRequired", { x: selectedBatch.consecutiveFrequency }));
						return;
					}
					break;
			}
		}

		let frequencyValueError = false
		const pricingPack = selectedPricingPack.pricingPack;
		if (isMonthDaysPerWeekPack(pricingPack) && pricingPack.frequencyValue &&
			selectedWeekDays?.length !== pricingPack.frequencyValue) {
			notification("error", formatMsg("selectXDaysOfTheWeek", { x: pricingPack.frequencyValue }))
			return
		}
		// if (
		// 	pricingPack.frequency === "CUSTOM" &&
		// 	pricingPack.noOfClasses &&
		// 	!pricingPack.unlimitedClasses &&
		// 	!selectedBatch.selectSlotsLater &&
		// 	selectedDays?.length < pricingPack.noOfClasses) {
		// 	notification("error", "Select " + pricingPack.noOfClasses + " classes")
		// 	return
		// }

		// if (
		// 	pricingPack.frequency === "WEEK" &&
		// 	pricingPack.frequencyValue &&
		// 	!pricingPack.all &&
		// 	selectedWeekDays?.length < pricingPack.frequencyValue) {
		// 	notification("error", "Select " + pricingPack.frequencyValue + " weekdays")
		// 	return
		// }

		if (
			pricingPack.frequency === "MONTH" &&
			pricingPack.frequencyType === "WEEKS" &&
			!pricingPack.all &&
			pricingPack.frequencyValue
		) {
			const weeksByMonth: Record<string, Set<string>> = {};

			selectedWeeks.forEach((weekLabel) => {
				const [, weekTimestampStr] = weekLabel.split("+");
				const startOfWeek = timeutil.getInstance(Number(weekTimestampStr));

				for (let i = 0; i < 7; i++) {
					const day = getInstanceClone(startOfWeek).add(i, "day");
					const monthKey = day.format("YYYY-MM");

					if (!weeksByMonth[monthKey]) {
						weeksByMonth[monthKey] = new Set();
					}

					weeksByMonth[monthKey].add(weekLabel);
				}
			});
			let missingOrInvalid = false;
			selectedMonths.forEach((month) => {
				const monthKey = month.format("YYYY-MM");
				const weeks = weeksByMonth[monthKey];

				if (!weeks || weeks.size !== pricingPack.frequencyValue) {
					notification(
						"error",
						`Select ${pricingPack.frequencyValue} weeks for ${month.format("MMMM YYYY")}`
					);
					missingOrInvalid = true;
				}
			});
			if (missingOrInvalid) {
				frequencyValueError = true;
			}
		}

		if (
			pricingPack.frequency === "MONTH" &&
			pricingPack.frequencyType === "DAYS" &&
			!pricingPack.all &&
			pricingPack.frequencyValue
		) {
			const daysByMonth = selectedDays.reduce((acc, day) => {
				const monthKey = timeutil.getEpoch(timeutil.getInstance(day).startOf("month")).toString();
				if (!acc[monthKey]) {
					acc[monthKey] = [];
				}
				acc[monthKey].push(day);
				return acc;
			}, {} as Record<string, Date[]>);

			if (Object.entries(daysByMonth)?.length != selectedMonths.length) {
				notification("error", `Select ${pricingPack.frequencyValue} days for each selected month`)
				frequencyValueError = true
			}
			else Object.entries(daysByMonth).forEach(([monthKey, days]) => {
				if (days.length !== pricingPack.frequencyValue) {
					notification(
						"error",
						`${pricingPack.frequencyValue} days need to be selected for month ${timeutil.getInstance(
							parseInt(monthKey, 10)
						).format("MMMM YYYY")}`
					);
					frequencyValueError = true;
				}
			});
		}
		if (frequencyValueError) return

		// selectedWeekDays is prefilled from the booking's existing slots, but the weekday picker is only
		// shown for WEEK packs of fewer than 7 days. For any other pack (e.g. MONTH) the filter must not
		// apply, otherwise a day moved to a new weekday is silently dropped from the saved slots.
		const reschedulePack = selectedPricingPack?.pricingPack;
		const weekDayFilter = ((reschedulePack?.frequency === "WEEK" && reschedulePack?.frequencyValue < 7) || isMonthDaysPerWeekPack(reschedulePack)) ? selectedWeekDays : [];
		const slots = [];
		for (const date of selectedDays) {
			const isRecurring = selectedBatch.type === "recurring";
			const day = timeutil.getInstance(date);
			let randomIds = [];
			const tempDate = isRecurring ? day.format("dddd").toUpperCase() : day.format(Helper.dateFormat(firebase));
			// Weekday filter must compare against day-of-week names regardless of batch type.
			const dayOfWeek = day.format("dddd").toUpperCase();
			if (weekDayFilter.length && !weekDayFilter.includes(dayOfWeek)) continue;
			Object.entries(selectedTimings).forEach(
				([actId, activitySelection]) => {
					if (activitySelection["Common slots"]) {
						const commonSlots = Array.isArray(activitySelection["Common slots"])
							? activitySelection["Common slots"]
							: [activitySelection["Common slots"]];

						commonSlots.forEach(commonSlotId => {
							const selectedSlotObj = selectedBatch.intervals.find(
								(obj: any) => obj.randomId === commonSlotId
							);
							if (!selectedSlotObj) return;

							const timeLabel = `${formatTime(selectedSlotObj.startTime)} - ${formatTime(selectedSlotObj.endTime)}`;

							const matches = selectedBatch.intervals.filter((obj: any) => {
								const objTime = `${formatTime(obj.startTime)} - ${formatTime(obj.endTime)}`;
								const objDayOrDate = isRecurring
									? obj.day
									: timeutil
										.getInstance(obj.date)
										.format(Helper.dateFormat(firebase));
								return objDayOrDate === tempDate && objTime === timeLabel && (actId === "default" ? !obj.activityId : obj.activityId === actId);
							});

							randomIds.push(...matches.map((m: any) => m.randomId));
						});
					}
					else {
						const dayKey = isRecurring
							? day.format("dddd").toUpperCase()
							: day.format(Helper.dateFormat(firebase));

						const sel = activitySelection[dayKey];
						if (sel) {
							const selArr = Array.isArray(sel) ? sel : [sel];
							randomIds.push(...selArr);
						}
					}
				}
			);

			if (randomIds.filter(i => i).length) {
				for (const randomId of randomIds) {
					const selectedInterval = selectedBatch.intervals.find(obj => obj.randomId === randomId);
					if (selectedInterval) {
						slots.push({
							randomId,
							date: timeutil.getEpoch(day),
							startTime: selectedInterval.startTime,
							endTime: selectedInterval.endTime,
							activityId: selectedInterval.activityId ?? null,
						});
					}
				}
			} else {
				notification("error", formatMsg("selectRequiredTimeSlots"));
				return;
			}
		}

		function prepareBookedCredits() {
			const pricingPack = selectedPricingPack?.pricingPack;
			if (!pricingPack) {
				return null;
			}

			// For CUSTOM with DURATION, we need durationValue and durationUnit
			if (pricingPack.frequency === "CUSTOM" && pricingPack.durationType === "DURATION") {
				if (!pricingPack.durationValue || !pricingPack.durationUnit) {
					return null;
				}
			} else if (!pricingPack.frequencyValue || pricingPack.all) {
				// For other frequencies, we need frequencyValue and it shouldn't be "all"
				return null;
			}

			const newBookedCredits: Array<{ periodStartDate: number; periodEndDate: number; creditsUsed: number }> = [];

			// Helper function to calculate windows from selected days for CUSTOM with DURATION
			const calculateWindowsFromDays = (days: Date[]) => {
				if (!pricingPack.durationValue || !pricingPack.durationUnit) {
					return [];
				}

				// Extract number of windows allowed from credits
				let maxWindows = 0;
				const creditsData = packageReducer.rescheduleData?.credits;
				if (typeof creditsData === 'object' && creditsData !== null && creditsData.totalCredits !== undefined) {
					maxWindows = creditsData.totalCredits;
				} else if (typeof creditsData === 'number') {
					maxWindows = creditsData;
				}

				const sortedDays = [...days].sort((a, b) => a.getTime() - b.getTime());
				const durationValue = pricingPack.durationValue;
				const durationUnit = pricingPack.durationUnit.toLowerCase();
				const windows: Array<{ start: Date; end: Date; days: Date[] }> = [];

				for (const day of sortedDays) {
					const dayInstance = timeutil.getInstance(day);
					let addedToWindow = false;

					// Check if this day falls within any existing window
					for (const window of windows) {
						const windowStart = timeutil.getInstance(window.start);
						const windowEnd = timeutil.getInstance(window.end);

						if ((timeutil.isSame(dayInstance, windowStart, "day") || timeutil.isAfter(dayInstance, windowStart, "day")) &&
							(timeutil.isSame(dayInstance, windowEnd, "day") || timeutil.isBefore(dayInstance, windowEnd, "day"))) {
							window.days.push(day);
							addedToWindow = true;
							break;
						}
					}

					// If not added to any existing window, check if we can create a new window
					if (!addedToWindow) {
						// Check if credits (number of windows) limit is reached
						if (maxWindows > 0 && windows.length >= maxWindows) {
							// Cannot create a new window - skip this day
							continue;
						}

						let windowStart = getInstanceClone(dayInstance).startOf("day");
						let windowEnd = getInstanceClone(windowStart);

						if (durationUnit === "months") {
							// For months: Nov 3 + 3 months = Feb 3 (inclusive, same day 3 months later)
							windowEnd = windowEnd.add(durationValue, "month").endOf("day");
						} else if (durationUnit === "weeks") {
							// Week-aligned window: snap start to start of week, end at end of (start + N-1) weeks.
							const ws = selectedBatch?.weekStartDay;
							const weekWindow = timeutil.consecutiveWeeksWindow(windowStart, durationValue, ws);
							windowStart = weekWindow.start;
							windowEnd = weekWindow.end;
						} else if (durationUnit === "days") {
							// For days: Nov 3 + 3 days = Nov 6 (inclusive, 3 days from Nov 3)
							windowEnd = windowEnd.add(durationValue - 1, "day").endOf("day");
						}

						// If batch ends before window, use batch's endDate
						if (selectedBatch?.endDate) {
							const batchEndDate = timeutil.getInstance(selectedBatch.endDate).endOf("day");
							if (timeutil.isAfter(windowEnd, batchEndDate)) {
								// Window extends beyond batch end, use batch endDate
								windowEnd = batchEndDate;
							}
						}

						windows.push({
							start: Helper.convertToDate(windowStart, firebase),
							end: Helper.convertToDate(windowEnd, firebase),
							days: [day]
						});
					}
				}

				return windows;
			};

			switch (pricingPack.frequency) {
				case "CUSTOM": {
					if (pricingPack.durationType === "DURATION") {
						// Calculate windows from selected days
						const windows = calculateWindowsFromDays(selectedDays);

						// Check if number of windows exceeds the limit
						if (maxWindows > 0 && windows.length > maxWindows) {
							notification("error", `Cannot create more than ${maxWindows} booking period(s). Currently selected: ${windows.length} period(s).`);
							return null;
						}

						// Create bookedCredits entry for each window
						windows.forEach(window => {
							const periodStartDate = timeutil.getEpoch(timeutil.getInstance(window.start).startOf("day"));
							const periodEndDate = timeutil.getEpoch(timeutil.getInstance(window.end).endOf("day"));
							const creditsUsed = window.days.length;

							if (creditsUsed > 0) {
								newBookedCredits.push({
									periodStartDate,
									periodEndDate,
									creditsUsed
								});
							}
						});
					} else {
						// For CUSTOM with DATES type or no durationType, return null
						return null;
					}
					break;
				}
				case "WEEK": {
					// Group selected days by week
					const weeksMap = new Map<string, Date[]>();
					selectedDays.forEach(day => {
						const weekStart = timeutil.getStartOfWeek(day, selectedBatch?.weekStartDay);
						const weekKey = timeutil.getEpoch(weekStart).toString();
						if (!weeksMap.has(weekKey)) {
							weeksMap.set(weekKey, []);
						}
						weeksMap.get(weekKey)!.push(day);
					});

					weeksMap.forEach((days, weekKey) => {
						const weekStart = timeutil.getInstance(parseInt(weekKey, 10));
						const periodStartDate = timeutil.getEpoch(weekStart);
						const periodEndDate = timeutil.getEpoch(timeutil.getEndOfWeek(weekStart, selectedBatch?.weekStartDay));

						// Count credits used in this week (filter by selected weekdays if applicable)
						const creditsUsed = days.filter(d => {
							if (weekDayFilter.length && !weekDayFilter.includes(timeutil.inFormat(d, "dddd").toUpperCase())) {
								return false;
							}
							return true;
						}).length;

						if (creditsUsed > 0) {
							newBookedCredits.push({
								periodStartDate,
								periodEndDate,
								creditsUsed
							});
						}
					});
					break;
				}

				case "MONTH": {
					if (pricingPack.frequencyType === "WEEKS") {
						// Group selected weeks by month
						const monthsMap = new Map<string, string[]>();
						selectedWeeks.forEach(weekLabel => {
							const [, weekTimestampStr] = weekLabel.split("+");
							const weekStart = timeutil.getInstance(Number(weekTimestampStr));
							const monthKey = weekStart.format("YYYY-MM");
							if (!monthsMap.has(monthKey)) {
								monthsMap.set(monthKey, []);
							}
							monthsMap.get(monthKey)!.push(weekLabel);
						});

						selectedMonths.forEach(month => {
							const monthKey = month.format("YYYY-MM");
							const weeks = monthsMap.get(monthKey) || [];
							const periodStartDate = timeutil.getEpoch(month.clone().startOf("month"));
							const periodEndDate = timeutil.getEpoch(month.clone().endOf("month"));

							// Count credits used: count days in selected weeks that fall within this month
							const creditsUsed = selectedDays.filter(day => {
								const dayEpoch = timeutil.getEpoch(timeutil.getInstance(day));
								return dayEpoch >= periodStartDate && dayEpoch <= periodEndDate;
							}).length;

							if (creditsUsed > 0) {
								newBookedCredits.push({
									periodStartDate,
									periodEndDate,
									creditsUsed
								});
							}
						});
					} else if (pricingPack.frequencyType === "DAYS") {
						// Group selected days by month
						const monthsMap = new Map<string, Date[]>();
						selectedDays.forEach(day => {
							const monthStart = timeutil.getInstance(day).startOf("month");
							const monthKey = timeutil.getEpoch(monthStart).toString();
							if (!monthsMap.has(monthKey)) {
								monthsMap.set(monthKey, []);
							}
							monthsMap.get(monthKey)!.push(day);
						});

						selectedMonths.forEach(month => {
							const monthKey = timeutil.getEpoch(month.clone().startOf("month")).toString();
							const days = monthsMap.get(monthKey) || [];
							const periodStartDate = timeutil.getEpoch(month.clone().startOf("month"));
							const periodEndDate = timeutil.getEpoch(month.clone().endOf("month"));
							const creditsUsed = days.length;

							if (creditsUsed > 0) {
								newBookedCredits.push({
									periodStartDate,
									periodEndDate,
									creditsUsed
								});
							}
						});
					}
					break;
				}

				case "DAILY": {
					// Each day is its own period
					selectedDays.forEach(day => {
						const dayInstance = timeutil.getInstance(day);
						const periodStartDate = timeutil.getEpoch(dayInstance.startOf("day"));
						const periodEndDate = timeutil.getEpoch(dayInstance.endOf("day"));

						newBookedCredits.push({
							periodStartDate,
							periodEndDate,
							creditsUsed: 1
						});
					});
					break;
				}

				default:
					return null;
			}

			// Merge with existing bookedCredits if available
			const existingBookedCredits = packageReducer.rescheduleData?.bookedCredits || [];
			const mergedCredits = [...existingBookedCredits];

			newBookedCredits.forEach(newEntry => {
				const existingIndex = mergedCredits.findIndex(
					existing => existing.periodStartDate === newEntry.periodStartDate &&
						existing.periodEndDate === newEntry.periodEndDate
				);
				if (existingIndex > -1) {
					// Update existing entry
					mergedCredits[existingIndex] = {
						periodStartDate: newEntry.periodStartDate,
						periodEndDate: newEntry.periodEndDate,
						creditsUsed: newEntry.creditsUsed
					};
				} else {
					// Add new entry
					mergedCredits.push(newEntry);
				}
			});

			return mergedCredits.length > 0 ? mergedCredits : null;
		}

		const bookedCredits = prepareBookedCredits();

		let startDate, endDate;
		if (bookedCredits && bookedCredits.length > 0) {
			// If bookedCredits exist, use min/max of period dates from bookedCredits
			startDate = Math.min(...bookedCredits.map(credit => credit.periodStartDate));
			endDate = Math.max(...bookedCredits.map(credit => credit.periodEndDate));
		} else {
			// Otherwise, use selected days
			startDate = Math.min(...selectedDays.map(d => timeutil.getEpoch(timeutil.getInstance(d))));
			endDate = Math.max(...selectedDays.map(d => timeutil.getEpoch(timeutil.getInstance(d))));
		}

		const payload = {
			"slots": slots.length ? slots : null,
			"id": open,
			"startDate": startDate,
			"endDate": endDate,
			bookedCredits: bookedCredits,
			"activities": Helper.getUniqueActivityIds(selectedTimings)
		}
		dispatch(rescheduleBooking({ firebase, payload }))
	}

	function getButtonGroup() {
		return (
			<div>
				{
					afterReSchedule &&
					<div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
						<PrefixIconButton
							title={formatMsg("close")}
							border={true}
							backgroundColor={colors.color_purple}
							fontColor={colors.color_white}
							onClick={() => {
								setAfterReSchedule(false)
								setOpen(false);
							}}
							borderRadius={"4px"}
						/>
					</div>}
			</div>
		)
	}

	useEffect(() => {
		setCommonAvailability(accountPackageReducer.maxCapacityPerBatchCenter);
	}, [])

	// A booking with recurring payments can't be rescheduled (its billing follows its dates). The
	// backend flags it on the reschedule data; say so up front instead of offering a date picker it
	// would refuse. Viewing dates (readOnly) and booking remaining class credits are not reschedules.
	const isReschedule = !readOnly && !remainingCredits;
	const rescheduleBlocked = isReschedule && !packageReducer.isLoading
		&& !!packageReducer.rescheduleData?.rescheduleBlocked;
	// Until the booking's details arrive we can't tell whether it may be rescheduled, so show only a
	// spinner — never the reschedule form and its button for a booking that will turn out blocked.
	const awaitingRescheduleData = isReschedule && !afterReSchedule
		&& (packageReducer.isLoading || !packageReducer.rescheduleData?.centerId);

	if (awaitingRescheduleData) {
		return (
			<ModalWrapper open={open} onCancel={() => setOpen(false)} footer={null} width={360}>
				<div style={{ display: "flex", justifyContent: "center", padding: "32px 0" }}><Spin /></div>
			</ModalWrapper>
		);
	}

	if (rescheduleBlocked) {
		return (
			<ModalWrapper
				title={formatMsg("reschedule")}
				open={open}
				onCancel={() => setOpen(false)}
				footer={[<Button key="ok" type="primary" onClick={() => setOpen(false)}>{formatMsg("ok")}</Button>]}
			>
				<p style={{ margin: 0 }}>{formatMsg("rescheduleBlockedRecurring")}</p>
			</ModalWrapper>
		);
	}

	return (
		<div>
			{!afterReSchedule && <ModalWrapper
				title={readOnly ? formatMsg(modalType || 'dates') : (remainingCredits ? formatMsg("bookSlots") : formatMsg("reschedule"))}
				okText={readOnly ? null : (remainingCredits ? formatMsg("book") : formatMsg("reschedule"))}
				open={open}
				onCancel={() => setOpen(false)}
				width={"fit-content"}
				onOk={readOnly ? undefined : onFinish}
				confirmLoading={accountPackageReducer.isLoading}
				footer={readOnly ? null : undefined}
			>
				{!packageReducer.isLoading && selectedBatch && selectedPricingPack?.pricingPack && Object.values(groupedTimings).length ?
					<BookingCalendar
                        periodCounting={packageReducer.rescheduleData?.allowanceCounting === PERIOD_COUNTING}
                        limitAnchor={packageReducer.rescheduleData?.startDate ?? null}
						selectedPricingPack={selectedPricingPack} selectedTimings={selectedTimings}
						selectedBatch={selectedBatch} selectedMonths={selectedMonths} currentMonth={currentMonth}
						setSelectedMonths={setSelectedMonths} setSelectedDays={setSelectedDays} disabled={disabled}
						selectedWeeks={selectedWeeks} setSelectedWeeks={setSelectedWeeks} selectedDays={selectedDays}
						setCurrentMonth={setCurrentMonth} selectedWeekDays={selectedWeekDays}
						setSelectedWeekDays={setSelectedWeekDays} setSelectedTimings={setSelectedTimings}
						firebase={firebase} handleTimingClick={handleTimingClick} groupedTimings={groupedTimings}
						packageActivityMap={packageActivityMap} setOpenActivityId={setOpenActivityId}
						readOnly={readOnly} viewAll={readOnly} hideDays={modalType === "timings"} hideTimings={modalType === "dates"}
						maxCapacityPerBatchCenter={accountPackageReducer.maxCapacityPerBatchCenter}
						commonAvailability={commonAvailability}
						setCommonAvailability={setCommonAvailability}
						allowWaitlist={accountPackageReducer.allowWaitlist}
						waitlistCapacity={accountPackageReducer.waitlistCapacity}
						batchSlotMap={accountPackageReducer.batchSlotMap}
						centerId={packageReducer.rescheduleData.centerId}
						credits={maxWindows}
						enrollmentRules={packageReducer.rescheduleData.enrollmentRules}
					/>
					: <Skeleton active style={{ width: 500 }} />
				}
			</ModalWrapper>}
			{
				afterReSchedule &&
				<div >
					<div className='res-cpo-overlay'>
						<div className='res-cpo-popup'>
							<p className='res-cpo-textAlignCenter fw-700' style={{ whiteSpace: "pre-wrap" }}>{formatMsg("afterReschedule")}</p>
							<div className='res-cpo-textAlignLeft mt-16'>
								<div className='res-popup-reschedule'>{formatMsg("yourNewSchedule") + ": " + timeutil.getInstance(accountPackageReducer?.reschedulingDetails?.startDate).format(Helper.dateFormat(firebase)) + "-" + timeutil.getInstance(accountPackageReducer?.reschedulingDetails?.endDate).format(Helper.dateFormat(firebase))}</div>
							</div>
							<div>{getButtonGroup()}</div>
						</div>
					</div>
				</div>
			}
			<ViewActivityModal
				activity={openActivityId ? packageActivityMap.get(openActivityId) : {}}
				setOpenActivityId={setOpenActivityId}
			/>
		</div>
	)
}

export default RescheduleBookingModal